import React from "react";
import { useDroppable } from "@dnd-kit/core";
import {
    SortableContext,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";
import { SortableItem } from "./SortItem";


const containerStyle = {
    background: "#00eeb21e",
    padding: 10,
    margin: 10,
    flex: 1,
    width: "15em"
};

export default function MyContainer(props) {
    const { id, items, which } = props;

    const { setNodeRef } = useDroppable({
        id
    });

    return (
        <SortableContext
            id={id.id}
            items={items}
            strategy={verticalListSortingStrategy}
        >
            <div ref={setNodeRef} style={containerStyle}>
                <h3>{which}</h3>
                <ul type="none">
                    {items.map((id) => (
                        <SortableItem key={id.id} id={id}/>
                    ))}
                </ul>
            </div>
        </SortableContext>
    );
}
